import React, { useState,useRef,useEffect } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import { X } from "lucide-react";
import PropTypes from "prop-types";
import { BsThreeDots } from "react-icons/bs";
import axios from "axios";
import BaseUrl from "../Components/BaseUrl";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
const ManageAttendeesModal = ({ isOpen, onClose, connection, invitedEventUsers,eventAttendeeUsers,slug,getInvitedEventUsers }) => {
  const [tabValue, setTabValue] = useState("attendees");
  const [invited, setInvited] = useState(invitedEventUsers);
  const [attendees, setAttendees] = useState(eventAttendeeUsers);
  const [openMenuFor, setOpenMenuFor] = useState(null);
  const dotsRefs = useRef({});
  const menuRefs = useRef({});
  useEffect(() => { 
    setInvited(invitedEventUsers);
    setAttendees(eventAttendeeUsers);
  }, [invitedEventUsers, eventAttendeeUsers]);
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openMenuFor == null) return;

      const dotEl = dotsRefs.current[openMenuFor];
      const menuEl = menuRefs.current[openMenuFor];
      if (
        dotEl &&
        menuEl &&
        !dotEl.contains(e.target) &&
        !menuEl.contains(e.target)
      ) {
        setOpenMenuFor(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openMenuFor]);

  if (!isOpen) return null;

  // const attendees = [
  //   {
  //     id: "1",
  //     name: "Shivam Mantri",
  //     role: "Organizer",
  //     title: "Software Developer at LogicSpice Consultancy Private Ltd.",
  //     isYou: true,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "2",
  //     name: "John Doe",
  //     role: "Member",
  //     title: "Designer at TechCorp",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "3",
  //     name: "Jane Smith",
  //     role: "Manager",
  //     title: "Product Manager at Innovate Ltd.",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "4",
  //     name: "Jane Smith",
  //     role: "Manager",
  //     title: "Product Manager at Innovate Ltd.",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  // ];
  // const invited = [
  //   {
  //     id: "1",
  //     name: "Shivam Mantri",
  //     role: "Organizer",
  //     title: "Software Developer at LogicSpice Consultancy Private Ltd.",
  //     isYou: true,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "2",
  //     name: "John Doe",
  //     role: "Member",
  //     title: "Designer at TechCorp",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "3",
  //     name: "Jane Smith",
  //     role: "Manager",
  //     title: "Product Manager at Innovate Ltd.",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
  //   {
  //     id: "4",
  //     name: "Jane Smith",
  //     role: "Manager",
  //     title: "Product Manager at Innovate Ltd.",
  //     isYou: false,
  //     avatar: "https://via.placeholder.com/40",
  //   },
    
  // ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const toggleMenu = (memberId) => {
    setOpenMenuFor((prev) => (prev === memberId ? null : memberId));
  };

  const Withdraw = async (id) => {
    try {
      const response = await axios.post(
        `${BaseUrl}removeEventInvite/${slug}/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        getInvitedEventUsers();
        Swal.fire({
          toast: true,
          position: "bottom-start",
          icon: "success",
          title: "User withdrawn from the event!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      }
     catch (error) {
      console.error("Error withdrawing invite:", error);
    }
  };
  

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full min-h-[400px] max-w-3xl max-h-[90vh] flex flex-col animate-fadeIn">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            Manage attendees
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Main Content (Tabs and Tab Panels) */}
        <div className="flex-1 overflow-y-auto">
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="manage attendees tabs"
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    padding: "8px 16px",
                    color: "text-gray-500",
                    "&:hover": {
                      color: "text-gray-700",
                    },
                  },
                  "& .Mui-selected": {
                    color: "text-gray-800",
                    borderBottom: "2px solid #22c55e",
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#22c55e", // Green indicator
                  },
                }}
              >
                <Tab label="Attendees" value="attendees" />
                <Tab label="Invited" value="invited" />
              </Tabs>
            </Box>

            {/* Attendees Tab */}
            <TabPanel value="attendees" sx={{ padding: "16px" }}>
              {attendees.length === 0 ? (
                <p className="text-gray-500 px-4">No attendees yet.</p>
              ) : (
                <div className="space-y-4 ">
                  <p className="text-sm text-gray-600 border-b border-gray-200 pb-2 px-4">
                    {attendees.length}{" "}
                    {attendees.length === 1 ? "person" : "people"}
                  </p>
                  {attendees.map((person) => (
                    <div
                      key={person.id}
                      className="flex items-center gap-3 py-2 border-b border-gray-200 px-4"
                    >
                      {person.profile ? (
                        <img
                          src={person.profile}
                          alt={person.name}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-10 h-10 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center">
                          {person.name.charAt(0).toUpperCase()}
                        </div>
                      )}

                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <h3 className="font-medium text-gray-900">
                            {person.name}
                          </h3>
                          {person.invited_by === "Organizer" && (
                            <span className="text-sm font-semibold text-gray-500">{person.invited_by}</span>
                          )}
                          {person.role && (
                            <span className="text-xs text-gray-500">
                              {person.role}
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-gray-600">
                          {person.headline}
                        </p>
                      </div>
                      {person.invited_by === "Organizer" ?(""): (
                        <div className=" flex items-center space-x-4">
                          <div className="relative">
                            <BsThreeDots
                              ref={(el) =>
                                (dotsRefs.current[person.user_id] = el)
                              }
                              className="text-3xl font-bold text-gray-700 p-1 hover:text-gray-900 hover:cursor-pointer hover:bg-gray-200 hover:rounded-full "
                              onClick={() => toggleMenu(person.user_id)}
                            />
                            {openMenuFor === person.user_id && (
                              <div
                                ref={(el) =>
                                  (menuRefs.current[person.user_id] = el)
                                }
                                className="absolute w-32 bg-white border border-gray-200 text-sm rounded-l-lg rounded-b-lg shadow-lg z-50 right-0 top-6"
                              >
                                <button
                                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                                  onClick={() => Withdraw(person.user_id)}
                                >
                                  Remove
                                </button>
                              </div>
                            )}
                          </div>
                          <button className="flex items-center justify-center bg-white text-gray-700  h-8 px-4 py-2  hover:bg-gray-200 rounded-md ">
                            Message
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </TabPanel>

            {/* Invited Tab */}
            <TabPanel value="invited" sx={{ padding: "16px" }}>
              {invited.length === 0 ? (
                <p className="text-gray-500 pb-4 px-4">
                  No invited attendees yet.
                </p>
              ) : (
                <div className="space-y-4 ">
                  <p className="text-sm text-gray-600 border-b border-gray-200 pb-2 px-4">
                    {invited.length}{" "}
                    {invited.length === 1 ? "person" : "people"}
                  </p>
                  {invited.map((person) => (
                    <div
                      key={person.id}
                      className="flex items-center gap-3 py-2 border-b border-gray-200 px-4"
                    >
                      {person.profile ? (
                        <img
                          src={person.profile}
                          alt={person.name}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-10 h-10 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center">
                          {person.name.charAt(0).toUpperCase()}
                        </div>
                      )}
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <h3 className="font-medium text-gray-900">
                            {person.name}
                          </h3>
                          {person.isYou && (
                            <span className="text-xs text-gray-500">You</span>
                          )}
                          {person.role && (
                            <span className="text-xs text-gray-500">
                              {person.role}
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-gray-600">
                          {person.headline}
                        </p>
                      </div>
                      <button
                        className="flex items-center justify-center bg-white text-gray-700  h-8 px-4 py-2  hover:bg-gray-200 rounded-md "
                        onClick={() => Withdraw(person.user_id)}
                      >
                        Withdraw
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </TabPanel>
          </TabContext>
        </div>

        {/* Footer (Fixed at Bottom) */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4 flex justify-end rounded-b-lg">
          <button
            onClick={onClose}
            className="bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

ManageAttendeesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  connection: PropTypes.arrayOf(PropTypes.object),
  slug: PropTypes.string,
};

export default ManageAttendeesModal;